<template>
  <BaseMenu
    :placement="'bottom-start'"
    :appendToBody="true"
    @closed="show_layout_menu = false"
  >
    <IconButton
      id="layout-add-btn"
      v-model="show_layout_menu"
      :icon="'layout_add'"
      :width="22"
      :height="22"
    />
    <template #menu="{closeMenu}">
      <ul>
        <li>
          <BaseMenuButton @click.stop="handleClick('canvas'), closeMenu()">
            <span>2D Canvas</span>
          </BaseMenuButton>
        </li>
        <li>
          <BaseMenuButton @click.stop="handleClick('3d-canvas'), closeMenu()">
            <span>3D Canvas</span>
          </BaseMenuButton>
        </li>
        <li>
          <BaseMenuButton @click.stop="handleClick('depth-map'), closeMenu()">
            <span>Depth Map</span>
          </BaseMenuButton>
        </li>
        <li>
          <BaseMenuButton @click.stop="handleClick('location-map'), closeMenu()">
            <span>Location Map</span>
          </BaseMenuButton>
        </li>
      </ul>
    </template>
  </BaseMenu>
</template>

<script setup>
import IconButton from '@/components/IconButton.vue';
import BaseMenu from '@/components/BaseMenu.vue';
import BaseMenuButton from '@/components/BaseMenuButton.vue';
import {
  ref,
} from 'vue';

const emit = defineEmits(['layout-selected']);

const show_layout_menu = ref(false);

function handleClick(layout) {
  emit('layout-selected', layout);
}

</script>

<style lang="scss" scoped>
#layout-add-btn {
  color: var(--color-primary);
}
</style>
